var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-form-group', {
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "id": `${_vm.id}-group`,
      "label": _vm.required ? `${_vm.label} ${_vm.$t('form.required')}` : _vm.label,
      "label-for": `${_vm.id}-field`
    }
  }, [_c('v-date-picker', {
    class: {
      disabled: _vm.disabled
    },
    attrs: {
      "id": `${_vm.id}-field`,
      "is24hr": "",
      "mode": _vm.mode,
      "locale": _vm.$i18n.locale,
      "min-date": _vm.minDate,
      "max-date": _vm.maxDate,
      "masks": _vm.mask,
      "is-required": "",
      "first-day-of-week": 2
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var inputValue = _ref.inputValue,
          inputEvents = _ref.inputEvents;
        return [_c('input', _vm._g({
          staticClass: "form-input form-control picker",
          class: {
            'picker-primary': !!inputValue && _vm.icon,
            'picker-danger': !inputValue && _vm.icon
          },
          attrs: {
            "disabled": _vm.disabled
          },
          domProps: {
            "value": inputValue
          }
        }, inputEvents))];
      }
    }]),
    model: {
      value: _vm.formValue,
      callback: function ($$v) {
        _vm.formValue = $$v;
      },
      expression: "formValue"
    }
  }), _c('div', [_vm._t("validation-messages")], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }